import gql from 'graphql-tag';
import RecipeTeaserDataFragment from './RecipeTeaserDataFragment.gql';

export default gql`
  fragment RecipeCollectionItemFragment on RecipeCollectionItem {
    id
    type
    data {
      id
      subsectionTitle
      subsectionDescription
      title
      recipes {
        ...RecipeTeaserDataFragment
      }
    }
  }
  ${RecipeTeaserDataFragment}
`;
